import {
	getModule,
	Module,
	VuexModule,
	Mutation,
	Action,
} from 'vuex-module-decorators';
import store from '@/store';
import mwz from '../mediumwarez';
import {
	CreateAccountSubmission, ValueText, UpdateAccountSubmission, ChangeSchemaSubmission,
	ExpireCurrentTokenSubmission,
	BanTokenSubmission,
	UpdateAccountRemarkSubmission,
	AccountMinimumData,
	ChangeProgramSubmission,
	Installers,
	UpdateAccountExprirySubmission,
} from '../models.def';
import fb from '../gobi-mw-firestore';
@Module({
	namespaced: true,
	name: 'mwx',
	store,
	dynamic: true,
})
class MediumwaresModule extends VuexModule {

	public allAccounts: AccountMinimumData[] = [];
	public installer32bit: string | null = null;
	public installer64bit: string | null = null;
	public installerVersion: string | null = null;

	public get softwareTypesVt(): ValueText[] {
		return [
			{ value: 'sql', text: 'SQL' },
			{ value: 'autocount', text: 'AutoCount' },
		];
	}


	@Mutation
	public m_updateAllAccounts(accounts: AccountMinimumData[]) {
		this.allAccounts = accounts.sort((a, b) => b.createdAt - a.createdAt);
	}
	@Mutation
	public m_updateInstallers(installers: Installers) {
		this.installer32bit = installers.x86;
		this.installer64bit = installers.x64;
		this.installerVersion = installers.version;
	}

	@Action
	public updateAllAccounts(accounts: AccountMinimumData[]) {
		this.m_updateAllAccounts(accounts);
	}
	@Action
	public updateInstallers(installers: Installers) {
		this.m_updateInstallers(installers);
	}


	@Action
	public async createAccount(submission: CreateAccountSubmission) {
		const result = await mwz.createAccount(submission);
		return result;
	}
	@Action
	public async expireCurrentToken(submission: ExpireCurrentTokenSubmission) {
		const result = await mwz.expireCurrentToken(submission);
		return result;
	}
	@Action
	public async updateAccountRemark(submission: UpdateAccountRemarkSubmission) {
		const result = await mwz.updateAccountRemark(submission);
		if (result.success) {
			const allAccounts = this.allAccounts.map((acc) => {
				if (acc.accountId === submission.accountId) {
					return { ...acc, ...submission };
				} else {
					return acc;
				}
			});
			this.m_updateAllAccounts(allAccounts);
		}
		return result;
	}
	@Action
	public async updateAccountExpiry(submission: UpdateAccountExprirySubmission) {
		const result = await mwz.updateAccountExpiry(submission);
		if (result.success) {
			const allAccounts = this.allAccounts.map((acc) => {
				if (acc.accountId === submission.accountId) {
					return { ...acc, ...submission };
				} else {
					return acc;
				}
			});
			this.m_updateAllAccounts(allAccounts);
		}
		return result;
	}
	@Action
	public async updateAccount(submission: UpdateAccountSubmission) {
		const result = await mwz.updateAccount(submission);
		if (result.success) {
			const allAccounts = this.allAccounts.map((acc) => {
				if (acc.accountId === submission.accountId) {
					return { ...acc, ...submission };
				} else {
					return acc;
				}
			});
			this.m_updateAllAccounts(allAccounts);
		}
		return result;
	}
	@Action
	public async banOrUnbanToken(submission: BanTokenSubmission) {
		const result = await mwz.banOrUnbanToken(submission);
		if (result.success) {
			const allAccounts = this.allAccounts.map((acc) => {
				if (acc.accountId === submission.accountId) {
					const newData: any = { ...acc };
					newData[submission.tokenPath] = submission.value;
					return newData;
				} else {
					return acc;
				}
			});
			this.m_updateAllAccounts(allAccounts);
		}
		return result;
	}
	@Action
	public async changeSchemaId(submission: ChangeSchemaSubmission) {
		const result = await mwz.changeSchemaId(submission);
		if (result.success) {
			const allAccounts = this.allAccounts.map((acc) => {
				if (acc.accountId === submission.accountId) {
					return { ...acc, ...submission };
				} else {
					return acc;
				}
			});
			this.m_updateAllAccounts(allAccounts);
		}
		return result;
	}
	@Action
	public async changeProgramId(submission: ChangeProgramSubmission) {
		const result = await mwz.changeProgramId(submission);
		if (result.success) {
			const allAccounts = this.allAccounts.map((acc) => {
				if (acc.accountId === submission.accountId) {
					return { ...acc, ...submission };
				} else {
					return acc;
				}
			});
			this.m_updateAllAccounts(allAccounts);
		}
		return result;
	}
	@Action
	public async syncNow(accountId: string) {
		const assert = fb.assertSupportLvl(1);
		if (!assert.success) { return assert; }
		const result = await mwz.syncNow(accountId);
		return result;
	}
	@Action
	public async purgeSync(accountId: string) {
		const assert = fb.assertSupportLvl(2);
		if (!assert.success) { return assert; }
		const result = await mwz.purgeSync(accountId);
		return result;
	}
	@Action
	public async sendLogs(params: { accountId: string, payload?: any }) {
		const assert = fb.assertSupportLvl(1);
		if (!assert.success) { return assert; }
		const result = await mwz.sendLogs(params.accountId, params.payload);
		return result;
	}
	@Action
	public async sendSettings(accountId: string) {
		const assert = fb.assertSupportLvl(1);
		if (!assert.success) { return assert; }
		const result = await mwz.sendSettings(accountId);
		return result;
	}
	@Action
	public async sendAccounts(accountId: string) {
		const assert = fb.assertSupportLvl(10);
		if (!assert.success) { return assert; }
		const result = await mwz.sendAccounts(accountId);
		return result;
	}
	@Action
	public async restart(accountId: string) {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		const result = await mwz.restart(accountId);
		return result;
	}
	@Action
	public async removeAccount(accountId: string) {

		const assert = fb.assertSupportLvl(10);
		if (!assert.success) { return assert; }
		const result = await mwz.removeAccount(accountId);
		return result;

	}


}


export default getModule(MediumwaresModule);
